<!--
 * @description: 自定义范围日期组件
 * @fileName: index.vue
 * @author: lili
 * @date: 2024-04-09
!-->
<template>
  <el-date-picker
    v-model="dateRange"
    type="datetimerange"
    popper-class="my-date-picker"
    start-placeholder="开始日期"
    range-separator="至"
    end-placeholder="结束日期"
    value-format="yyyy-MM-dd HH:mm:ss"
    :clearable="clearable"
    :unlink-panels="unlinkPanels"
    :default-time="defaultTime"
    :picker-options="pickerOptions"
    @blur="pickerMinDate=''"
    @change="handleChange"
  />
</template>

<script>

export default {
  name: 'MyDatePicker',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    startPlaceholder: {
      type: String,
      default: '开始日期'
    },
    endPlaceholder: {
      type: String,
      default: '结束日期'
    },
    // 在范围选择器里取消两个日期面板之间的联动
    unlinkPanels: {
      type: Boolean,
      default: true
    },
    // 是否显示清除按钮
    clearable: {
      type: Boolean,
      default: false
    },
    // 选中日期后的默认具体时刻
    defaultTime: {
      type: Array,
      default: () => ['00:00:00', '23:59:59']
    },
    limitRange: {
      type: Number,
      default: 90
    }
  },
  data() {
    return {
      pickerMinDate: '',
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime()
          if (maxDate) {
            this.pickerMaxDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate !== '') {
            const limitRange = this.limitRange * 24 * 3600 * 1000 // 90天范围内可选
            const maxTime = this.pickerMinDate + limitRange
            const minTime = this.pickerMinDate - limitRange
            return (
              time.getTime() > maxTime ||
              time.getTime() < minTime
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      dateRange: this.value
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        /** 初始化范围 */
        this.dateRange = value
      }
    }
  },
  methods: {
    handleChange() {
      this.$emit('input', this.dateRange)
      this.$emit('change')
    }
  }
}
</script>

<style lang='scss'>
.my-date-picker
  .el-picker-panel__footer
  .el-button--text.el-picker-panel__link-btn {
  display: none;
}
</style>
